import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';
import { HttpServiceService } from './http-service.service';

@Injectable({
  providedIn: 'root'
})
export class AdsService {
  public GetAdsURL = "Ads/GetAds";
  public GetOffersCategoriesURL = "Offers/GetOffersCategories";
  public GetOffersPaginatedURL = "Offers/GetOffersPaginated";
  public SaveFavouritURL = "Offers/SaveFavouriteOffers";
  public GetFavouriteOffersPaginatedURL = "Offers/GetFavouriteOffersPaginated";
  public GetFavouriteOffersURL = "Offers/GetFavouriteOffers";


  

  
  constructor(private config: ConfigService, private http: HttpServiceService, private auth: AuthService) { }


  GetAds( ) {
    return new Promise((resolve, reject) => {
      this.http.postToOpenApi(this.config.server + this.GetAdsURL, {}).subscribe((res: any) => {
        console.log('GetAds', res)
        resolve(res)

      }, (Error) => {
        resolve(Error);
      })

    })

  }
  GetOffersCategories() {
    return new Promise((resolve, reject) => {
      this.http.postToOpenApi(this.config.server + this.GetOffersCategoriesURL,{}).subscribe((res: any) => {
        console.log('GetOffersCategories', res)

        resolve(res)

      }, (Error) => {
        resolve(Error);
      })

    })

  }
  GetOffersPaginated(Category,CardCode,IsFlashDeals,PageNo) {
    return new Promise((resolve, reject) => {
      this.http.postToOpenApi(this.config.server + this.GetOffersPaginatedURL, {Category:Category,CardCode:CardCode,IsFlashDeals:IsFlashDeals,PageNo:PageNo}).subscribe((res: any) => {
        console.log('GetOffersPaginated', res)
        resolve(res)
      }, (Error) => {
        resolve(Error);
      })

    })

  }

  SaveFavourite(Offerid,token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.SaveFavouritURL, {Offerid:Offerid},token).subscribe((res: any) => {
        console.log('SaveFavourite', res)
        resolve(res)
      }, (Error) => {
        resolve(Error);
      })

    })

  }

  GetFavouriteOffersPaginated(PageNo,token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetFavouriteOffersPaginatedURL, {PageNo:PageNo},token).subscribe((res: any) => {
        console.log('GetFavouriteOffersPaginated', res)
        resolve(res)
      }, (Error) => {
        resolve(Error);
      })

    })

  }

  GetFavouriteOffers(token) {
    return new Promise((resolve, reject) => {
      this.http.postToCloseApi(this.config.server + this.GetFavouriteOffersURL, {},token).subscribe((res: any) => {
        console.log('GetFavouriteOffers', res)
        resolve(res)
      }, (Error) => {
        console.log('GetFavouriteOffersError', Error)
        resolve(Error);

      })

    })

  }
}
